import API from 'services/TAPS_API';

export default function getDraft() {
  return API.request({
    method: 'GET',
    url: `/notification/1150076`,
  });
}
